import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import { fetchNavbarAndFooter } from "lib/fetchers/common";
import { fetchGenericPageData } from "lib/fetchers/genericPage";
import type { GenericPageData } from "lib/fetchers/genericPage";
import type { NavData, FooterData } from "lib/types/common";

import GenericPageView from "content-ui/genericPages/index";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";

const PAGE_SLUG = "ai-code-of-conduct";

export async function getStaticProps({ preview = false }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchGenericPageData({ pageSlug: PAGE_SLUG, preview }),
  ]);

  if (!dato) {
    return { notFound: true, revalidate: 5 };
  }

  return {
    props: {
      dato,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every minute
    revalidate: 60,
  };
}

type PageProps = {
  navMenuItems: NavData;
  footerMenuItems: FooterData;
  dato: GenericPageData;
};

const AiCodeOfConductPage = (props: PageProps) => {
  const { title, description, image } = props.dato.seo;

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/ai-code-of-conduct"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: image?.url }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />
      <ErrorBoundary>
        <GenericPageView {...props.dato} />
      </ErrorBoundary>
      <Footer />
    </>
  );
};

export default AiCodeOfConductPage;
